<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [class]="extraClass"
    [title]="'Pro Request'"
    [canGoBack]="true" />
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  @if (windowService.isDesktopRes) {
    <tidy-loading-bar class="js-tidy-loading" />
  }
  <tidy-wrapper>

    @if (request) {
      <tidy-card>
        <!--CRAF Template / Pending request_type-->
        @if (request?.template_data?.request_type === 'pending') {
          <tidy-row class="extra-bottom-padding vertical-align-center">
            <tidy-image
              [src]="'assets/icon/searching.svg'"
              class="header-size wiggle-animation" />
            <tidy-text
              [header]="'Request Pending'" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding">
            <tidy-text
              [body]="requests.getProRequestBody(request)" />
          </tidy-row>
          @for (day of requests.buildRequestTimeList(request?.template_data?.availability_request?.request_times); track day) {
            <tidy-row class="extra-bottom-padding">
              <tidy-text
                [body]="day" />
            </tidy-row>
          }
          <!--<ng-container *ngIf="request?.template_data?.availability_request?.service_type == 'custom'">
          <tidy-row>
            <tidy-button
              [text]="'Assign Pro'"
              [action]="goToChangePro.bind(this, request)"
              class="primary">
            </tidy-button>
          </tidy-row>
        </ng-container>-->
        <tidy-row [align]="'center'">
          <tidy-text
            (action)="cancelProRequest(request?.template_data?.availability_request)"
            [body]="'Cancel Request'"
            class="link" />
        </tidy-row>
        @if (bookingFormAnswers?.length > 0) {
          <tidy-row class="extra-top-padding extra-bottom-padding">
            <tidy-divider />
          </tidy-row>
          <tidy-row class="vertical-align-center extra-bottom-padding">
            <tidy-image
              [src]="'assets/img/information.svg'"
              class="header-size" />
            <tidy-text
              [header]="'Job Note'" />
          </tidy-row>
          @for (answer of bookingFormAnswers; track answer) {
            @if (answer?.template_input?.type == 'text' || answer?.template_input?.type == 'text_area') {
              <tidy-row>
                <tidy-text
                  [body]="answer?.template_input?.label + ': ' + answer?.data?.value" />
              </tidy-row>
              @if (answer?.template_input?.image_url) {
                <tidy-photo-note
                  [src]="answer?.template_input?.image_url" />
              }
            }
            @if (answer?.template_input?.type == 'select') {
              <tidy-row>
                <tidy-text
                  [body]="answer?.template_input?.label + ': ' + me.getBookingFormSelectValue(answer?.data?.value)" />
              </tidy-row>
              @if (answer?.template_input?.image_url) {
                <tidy-photo-note
                  [src]="answer?.template_input?.image_url" />
              }
            }
            @if (answer?.template_input?.type == 'multiselect') {
              <tidy-row>
                <tidy-text
                  [body]="answer?.template_input?.label + ': ' + me.getBookingFormMultiselectValue(answer?.data?.value)" />
              </tidy-row>
              @if (answer?.template_input?.image_url) {
                <tidy-photo-note
                  [src]="answer?.template_input?.image_url" />
              }
            }
            @if (answer?.template_input?.type == 'file' && answer?.template_input?.data?.type == 'image') {
              <tidy-row>
                <tidy-text
                  [body]="answer?.template_input?.label" />
              </tidy-row>
              <tidy-carrousel
                class="photo-notes-carrousel only-padding-bottom"
                [scaleImages]="true">
                <tidy-photo-note
                  *tidyCarrousel
                  [src]="answer?.data?.value" />
              </tidy-carrousel>
            }
            @if (answer?.template_input?.type == 'files'  && answer?.template_input?.data?.type == 'images') {
              <tidy-row>
                <tidy-text
                  [body]="answer?.template_input?.label" />
              </tidy-row>
              <tidy-carrousel
                class="photo-notes-carrousel only-padding-bottom"
                [scaleImages]="true">
                @for (imageUrl of answer?.data?.value; track imageUrl) {
                  <tidy-photo-note
                    *tidyCarrousel
                    [src]="imageUrl" />
                }
              </tidy-carrousel>
            }
          }
        }
      }
      <!--CRAF Template / Countered request_type-->
      @if (request?.template_data?.request_type === 'countered') {
        <tidy-row class="extra-bottom-padding vertical-align-center">
          <tidy-image
            [src]="'assets/img/request-counter.svg'"
            class="title-size" />
          <tidy-text
            [header]="request?.template_data?.homekeeper?.homekeeper_name"
            [translate]="false" /><span>&nbsp;</span>
            <tidy-text
              [header]="'Proposed Other Times'" />
          </tidy-row>
          <tidy-row class="extra-bottom-padding">
            <tidy-text
              [body]="request?.template_data?.homekeeper?.homekeeper_name"
              [translate]="false" />
            <tidy-text
              [body]="' indicated that they were not available for the times you requested, but provided other times they are available.'" />
          </tidy-row>
          <tidy-button
            [text]="'View Other Times'"
            [action]="goToRequestProCounter.bind(this, request?.template_data?.availability_request, request?.template_data?.homekeeper)"
            class="primary" />
        }
      </tidy-card>
    }

  </tidy-wrapper>
</ng-template>

@if (!windowService.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (windowService.isDesktopRes) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}